import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ComboItemGroupModel } from 'src/app/models/combo';
import { ItemDisplayData } from 'src/app/models/item-display-data';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { ItemMenuService } from 'src/app/services/item-menu.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-pick-combo-item',
  templateUrl: './pick-combo-item.component.html',
  styleUrls: ['./pick-combo-item.component.scss']
})
export class PickComboItemComponent implements OnInit
{
  itens:Array<ItemDisplayData> = [];
  itemGroup:ComboItemGroupModel = new ComboItemGroupModel();
  currentPriceString = '';

  constructor(
    private itemmenuservice:ItemMenuService, 
    private initializationservice:InitializationService, 
    private route: ActivatedRoute, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService,
    public alertDialog: MatDialog,
    private router: Router,
    private localeservice: LocaleService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    var itemgroupuid = String(this.route.snapshot.paramMap.get('itemgroupuid'))

    this.itemGroup = this.currentorderservice.getComboItemGroup(itemgroupuid);

    var itens = this.itemmenuservice.getItemGroupItensDisplayData(this.itemGroup.ItemPresetList);

    if(this.itemGroup.AllowEmpty)
      itens.splice(0,0, new ItemDisplayData("","","","", "Nenhum", "Nenhuma das opções.", "", "", "", false, ""));

    this.itens = itens;

    this.currentPriceString = this.localeservice.getCurrencyString(this.currentorderservice.getCurrentComboPrice());
  }

  back()
  {
    this.navigationservice.back();
  }

  itemTap(itemData:ItemDisplayData)
  {
    if(itemData.UniversalID.length > 0)
    {
      var appname = String(this.route.snapshot.paramMap.get('appname'));

      var status = String(this.route.snapshot.queryParamMap.get('status'));

      this.router.navigateByUrl('/' + appname + '/comboitem/' + itemData.UniversalID + '?status=' + status+ '&itemgroupuid=' + this.itemGroup.ID, { replaceUrl:true });
    }
    else
    {
      this.currentorderservice.setNoComboItem(this.itemGroup);

      this.navigationservice.back();
    }
  }
}
